module.exports = __webpack_public_path__ + "img/gb9120_4_b.prt.79024373.jpg";